module.exports = __webpack_public_path__ + "static/logo-aadc196e7a6d5fcb8f822b4950a2fbc4.png";